import {Component, EventEmitter, Input, OnInit, Output, SimpleChanges} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {CategoryService} from '../../_services';
import {Category, Intercalaire, SubCategory} from '../../_models';
import {first} from 'rxjs/operators';

@Component({
  selector: 'app-edit-category',
  templateUrl: './edit-category.component.html',
  styleUrls: ['./edit-category.component.scss']
})
export class EditCategoryComponent {

    @Input() category: Category;
    @Input() subCategory: SubCategory;
    @Output() refreshEvent = new EventEmitter<string>();
    errors = [];

    categoryForm = new FormGroup({
        name: new FormControl(''),
    });

    constructor(private categoryService: CategoryService) { }

    ngOnChanges(changes: SimpleChanges) {

      if (this.category) {
          this.categoryForm = new FormGroup({
              name: new FormControl(this.category.name),
          });
      }

      if (this.subCategory) {
          this.categoryForm = new FormGroup({
              name: new FormControl(this.subCategory.name),
          });
      }
    }

    submit() {

        this.errors = [];
        let isOK = true;

        if (this.categoryForm.value.name === '') {
          this.errors[`name`] = true;
          isOK = false;
        }

        if (!isOK) {
          return;
        }

        if (this.category) {
            this.category.name = this.categoryForm.value.name;

            this.categoryService.update(this.category).pipe(first()).subscribe(result => {
                this.refreshEvent.next();
            });
        }

        if (this.subCategory) {
            this.subCategory.name = this.categoryForm.value.name;

            this.categoryService.updateSubCategory(this.subCategory).pipe(first()).subscribe(result => {
                this.refreshEvent.next();
            });
        }
    }

}
